<template>
  <div
    class="h-16 flex items-center m-1 bg-white rounded-md px-3 py-1 gap-3 shadow active:bg-gray-100"
    @click.stop.prevent="onClick(row.value._id)"
  >
    <i class="icon-property text-lg text-gray-700"></i>
    <div class="h-full w-full overflow-hidden *:leading-tight flex flex-col justify-center">
      <div class="text-base text-gray-900 font-bold">
        <span v-for="part of row.mainParts" :class="part.match ? 'text-cyan-700 bg-cyan-100 rounded' : ''">{{
          part.text
        }}</span>
      </div>
      <div class="text-xs text-gray-700">
        <span v-for="part of row.subParts" :class="part.match ? 'text-cyan-700 bg-cyan-100 rounded' : ''">{{
          part.text
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Prediction } from '@/components/forms/typeahead/type-ahead';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { PropertySearchRow } from 'common';

defineProps<{
  row: Prediction<PropertySearchRow>;
}>();

const emit = defineEmits<{
  (e: 'resultClicked', propertyId: string): void;
}>();

function onClick(propertyId: string) {
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
  emit('resultClicked', propertyId);
}
</script>

<style scoped></style>
